// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"c2888ee7","842":"157ab6ec","968":"d51cfab9"}[chunkId] + ".chunk.js";
};